import { submitClientErrorLog } from 'helpers/utils/utils';
import { useEffect, useCallback } from 'react';

const CHUNK_RETRY_KEY = 'chunk-retry-done';

export const useChunkErrorRecovery = () => {
  //logic reload
  const handleChunkError = useCallback((error: Error) => {
    const message = error.message || "";
    const stack = error.stack || "";
    const isChunkError = /Loading (CSS )?chunk|ChunkLoadError|Unexpected token '<'/.test(message);
    if (isChunkError) {
      if (!sessionStorage.getItem(CHUNK_RETRY_KEY)) {
        sessionStorage.setItem(CHUNK_RETRY_KEY, 'true');
        console.warn("Chunk load failed. Triggering automatic reload...");
        window.location.reload();
      }
    }
    submitClientErrorLog(
      isChunkError ? `[FE_CHUNK_ERROR]: ${message}` : `[FE_RENDER_ERROR]: ${message}`,
      stack,
      ''
    ); 
  }, []);

  // Rest session storage when component mounted
  useEffect(() => {
    if (sessionStorage.getItem(CHUNK_RETRY_KEY)) {
      const timeout = setTimeout(() => {
        sessionStorage.removeItem(CHUNK_RETRY_KEY);
        console.log("Chunk retry flag cleared.");
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, []);

  return { handleChunkError };
};